import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";

import { Fieldset } from "rbx";
import Section from "../Section";

import { EditFormButtonGroup } from "../inputs";

import UserGroupForm from "./UserGroupForm";

import {
  UPDATE_USER_GROUP_MUTATION,
  DELETE_USER_GROUP_MUTATION
} from "../../graphql/UserGroups/UserGroups.graphql";
import { ourToast as toast } from "../../utils";

class EditUserGroupForm extends Component {
  state = {
    GroupId: "",
    Name: "",
    Description: "",
    CompanyId: "",
    Active: true,
    ...this.props.group
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const { Active, GroupId, Name, Description, CompanyId } = this.state;
    const { setModalOpen } = this.props;

    return (
      <Mutation
        mutation={UPDATE_USER_GROUP_MUTATION}
        refetchQueries={["ALL_USER_GROUPS_QUERY"]}
        variables={{
          data: {
            GroupId,
            Name,
            Description,
            CompanyId,
            Active
          },
          where: { RecId: this.props.group.RecId }
        }}
      >
        {(updateUserGroup, { loading, error }) => (
          <Section title="Edit User Group">
            <form
              id="edit-user-group"
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await updateUserGroup();
                  setModalOpen();
                  toast.success("User Group updated successfully.");
                } catch (err) {
                  toast.error("Error updating User Group.");
                }
              }}
            >
              <Fieldset disabled={loading}>
                <UserGroupForm
                  inputs={{
                    GroupId,
                    Name,
                    Description,
                    CompanyId,
                    Active
                  }}
                  onChange={this.onChange}
                />
                <EditFormButtonGroup
                  deleteMutation={DELETE_USER_GROUP_MUTATION}
                  form="edit-user-group"
                  refetchQueries={["ALL_USER_GROUPS_QUERY"]}
                  variables={{ where: { RecId: this.props.group.RecId } }}
                  onComplete={setModalOpen}
                />
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

EditUserGroupForm.propTypes = {
  setModalOpen: PropTypes.func,
  group: PropTypes.object
};
export default EditUserGroupForm;
